import './policy.component.scss';
import {setInfoToLinks} from "../../../utils/setInfoToLinks.js";
import {config} from "../../../config.js";

export class PolicyComponent {
    emailLinkElements = document.querySelectorAll("[data-email-link]");
    telegramChashkinLinkElements = document.querySelectorAll('[data-telegram-chashkin-link]');

    constructor() {
        this.setConfigInfo();
    }

    setConfigInfo() {

        // ссылки на email
        setInfoToLinks(this.emailLinkElements, config.emailHref, config.email);

        // ссылки на телеграмм chashkin
        setInfoToLinks(this.telegramChashkinLinkElements, config.telegramChashkin);

    }

}